import { Component } from '@angular/core';
import { huntersDetailUrl } from '../../generic/service/planthunter.service';
import { PlanthunterOverviewComponent } from '../../generic/component/planthunter/planthunter.overview.component';
import { HuntersIntroComponent } from './hunters.intro.component';
import { HuntersBannerComponent } from './hunters.banner.component';

/**
 * A Hunter Overview component used as the base entry point for the KvK Shop '/hunters' route.
 * This component will add the necessary html formatting that is normally set in the site/jsp code.
 * Inside this html the actual planthunter overview will be rendered on the page.
 *
 * @author Patrick van Zadel
 */
@Component({
    selector: 'hunters-overview',
    templateUrl: 'hunters.overview.component.html',
    standalone: true,
    imports: [
        HuntersBannerComponent,
        HuntersIntroComponent,
        PlanthunterOverviewComponent,
    ],
})
export class HuntersOverviewComponent {
    constructor() {}

    getHuntersDetailUrl(): string {
        return huntersDetailUrl;
    }
}
